import React, {useState} from "react";
import '../App.css';
import BlogPage from "../features/blog/BlogPage";


function Blog() {
  window.scrollTo(0, 0);
  return <BlogPage />;
}

export default Blog;
